import * as React from "react";
import { connect } from "react-redux";

interface IProps {
  onClick?: (value: string | number) => void;
  currentYear?: string;
  options: string[];
}

const handleOnClick = (
  event: any,
  callback: ((value: string | number) => void) | undefined = undefined
) => {
  if (!!callback) {
    callback(event.target.value);
  }
};

const YearPicker = (props: IProps) => (
  <span className="bg-grey-lighter rounded-full py-1 py-1 my-2 inline-block">
    <select
      name="yearSelect"
      id="yearSelect"
      className="year-picker font-montserrat font-bold pr-6 mx-4 text-cct-blue text-sm appearance-none"
      disabled={props.options.length === 0}
      onChange={e =>
        handleOnClick(e, !!props.onClick ? props.onClick : undefined)
      }
      defaultValue={props.currentYear}
    >
      {props.options.length > 0 ? (
        props.options.map((year, index) => (
          <option
            key={index}
            value={year}
          >
            {year}
          </option>
        ))
      ) : (
        <option>loading...</option>
      )}
    </select>
  </span>
);

const mapStateToProps = (state: any) => ({
  options: state.selectables.years
});

 // const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(
  mapStateToProps
)(YearPicker);



// WEBPACK FOOTER //
// ./src/components/general/YearPicker.tsx